import React from "react";
import styles from "./PaginationBar.module.css";

const PaginationBar = ({
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(startIndex + itemsPerPage - 1, totalItems);

  const renderPageButtons = () => {
    const buttons = [];
    const maxVisible = 5;

    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      buttons.push(
        <button key={1} onClick={() => onPageChange(1)} className={styles.pageButton}>1</button>,
        <span key="dots-start" className={styles.ellipsis}>...</span>
      );
    }

    for (let i = start; i <= end; i++) {
      buttons.push(
        <button
          key={i}
          className={`${styles.pageButton} ${i === currentPage ? styles.active : ""}`}
          onClick={() => onPageChange(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      buttons.push(
        <span key="dots-end" className={styles.ellipsis}>...</span>,
        <button key={totalPages} onClick={() => onPageChange(totalPages)} className={styles.pageButton}>
          {totalPages}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className={styles.container}>
      <span className={styles.statusText}>
        Displaying <strong>{startIndex}</strong> - <strong>{endIndex}</strong> of <strong>{totalItems}</strong>
      </span>

      <div className={styles.buttonGroup}>
        <button
          className={styles.pageButton}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {renderPageButtons()}

        <button
          className={styles.pageButton}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PaginationBar;
